import React from 'react';
import Header from '../Header';

function Main(props) {
    return (
        <>
            <main>
                <Header/>
            </main>
          
        </>
    );
}

export default Main;